import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  AtRiskKpiRequest,
  AtRiskKpiResponse,
} from '../../types/Manager/atRiskAssociates.types';

// ======================================
// Get KPI Cards
// ======================================

export const getAtRiskKpiCards = async (
  request: AtRiskKpiRequest
): Promise<AtRiskKpiResponse> => {

  const payload: AtRiskKpiRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    fromDate: request.fromDate,
    toDate: request.toDate,
    productivityThreshold: request.productivityThreshold,
    noOfDays: request.noOfDays,
    idleThreshold: request.idleThreshold,
    activeHoursThreshold: request.activeHoursThreshold,
    nonProdThreshold: request.nonProdThreshold,
    attendanceThreshold: request.attendanceThreshold,
  };

  console.log('==============================');
  console.log('KPI Cards Request');
  console.log(payload);
  console.log('==============================');

  try {
    const { data } = await api.post<AtRiskKpiResponse>(
      ENDPOINTS.RISK_KPI_CARDS,
      payload
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn('KPI Cards API returned 404. Returning empty object.');

      return {
        atRiskThisWeek: 0,
        criticalRisk: 0,
        oneOnOneScheduled: 0,
        improvedLastWeek: 0,
        onTrack: 0,
        improvedFrom: 0,
        multiRiskFlagCount: 0,
        totalAtRisk: 0,
        exitedRiskCount: 0,
        totalAssociates: 0,
      };
    }

    console.error('KPI Cards API Error:', error);
    throw error;
  }
};